<template>
  <v-expansion-panels flat accordion multiple :value="state" v-model="expanded">
    <v-expansion-panel v-for="(item, i) in items" :key="item.id.toString()">
      <v-expansion-panel-header
        class="text-uppercase px-0"
        @click="expandHandler(i)"
      >
        <span class="text-tcdc-green header bold">{{ item[`title_${lang}`] }}</span>
        <template v-slot:actions>
          <v-icon v-if="expanded.some(index => i === index)" class="text-tcdc-green" size="medium">mdi-minus</v-icon>
          <v-icon v-else class="text-tcdc-green" size="medium">mdi-plus</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <!-- <Membership v-if="item.layout == 1" /> -->
        <TcdcMember v-if="item.layout == 2" />
        <MemberRate v-if="item.layout == 3" />
        <MemberBenefit v-if="item.layout == 4" />
        <!-- <Layout4 v-if="item.layout == 4" />
        <Layout5 v-if="item.layout == 5" />-->
        <!-- <div v-else>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
          veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat.
        </div>-->
      </v-expansion-panel-content>
      <Divider v-if="i+1 !== items.length" />
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import Divider from "../../components/dividers/Divider";
// import Membership from "../../components/member_layouts/Membership";
const TcdcMember = () => import("../../components/member_layouts/TcdcMember");
const MemberRate = () => import("../../components/member_layouts/MemberRate");
const MemberBenefit = () => import("../../components/member_layouts/MemberBenefit");
import { mapState } from 'vuex';
// import Layout4 from "../../components/member_layouts/Layout4";
// import Layout5 from "../../components/member_layouts/Layout5";
export default {
  props: {
    items: {
      default: []
    },
    state: {
      default: null
    }
  },
  data: () => ({
    expanded: []
  }),
  created() {
    if (this.state) {
      this.expanded.push(this.state);
    }
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang
    })
  },
  components: {
    Divider,
    // Membership,
    TcdcMember, // it's a wuswug
    MemberRate,
    MemberBenefit
    // Layout4,
    // Layout5,
  },
  methods: {
    expandHandler(index) {
      // const prev = this.expanded[index];
    }
  }
};
</script>

<style></style>
